/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from '@angular-kit/authentication';
import { TimeClockShellComponent } from './component/time-clock-shell/time-clock-shell.component';
import { TimeClockIdleComponent } from './component/time-clock-idle/time-clock-idle.component';
import { TimeClockRegisterComponent } from './component/time-clock-register/time-clock-register.component';
import { TimeClockEmployeeComponent } from './component/time-clock-employee/time-clock-employee.component';
import { TagInfoResolverService } from './service/tag-info-resolver.service';

const routes: Routes = [{
  path: 'time-clock/:id',
  canActivate: [AuthenticationGuard],
  component: TimeClockShellComponent,
  children: [
    {
      path: 'idle',
      component: TimeClockIdleComponent
    },
    {
      path: 'register/:token',
      component: TimeClockRegisterComponent
    },
    {
      path: 'employee/:nfc-key',
      resolve: {
        keyInfo: TagInfoResolverService
      },
      component: TimeClockEmployeeComponent
    },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TimeClockRoutingModule {}
